
export default function Services() {
  const services = [
    {
      icon: 'ri-user-search-line',
      title: 'Executive Search',
      description: 'Strategic leadership recruitment for C-suite and senior management positions with proven track records.',
      color: 'bg-blue-100 text-blue-600'
    },
    {
      icon: 'ri-time-line',
      title: 'Contract Staffing',
      description: 'Flexible workforce solutions for temporary, contract, and project-based hiring needs.',
      color: 'bg-purple-100 text-purple-600'
    },
    {
      icon: 'ri-user-add-line',
      title: 'Permanent Placement',
      description: 'End-to-end recruitment services for full-time positions across all organizational levels.',
      color: 'bg-teal-100 text-teal-600'
    },
    {
      icon: 'ri-team-line',
      title: 'RPO Solutions',
      description: 'Comprehensive recruitment process outsourcing to streamline your entire hiring function.',
      color: 'bg-orange-100 text-orange-600'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Talent Assessment',
      description: 'Advanced evaluation tools and methodologies to identify the best-fit candidates for your organization.',
      color: 'bg-green-100 text-green-600'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Workforce Consulting',
      description: 'Strategic workforce planning and talent management advisory services for business growth.',
      color: 'bg-pink-100 text-pink-600'
    }
  ];

  return (
    <section id="services" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Our Recruitment Services
          </h2>
          <p className="text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Comprehensive talent acquisition solutions tailored to your unique business needs and industry requirements
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-xl border border-gray-200 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer group"
            >
              <div className={`w-16 h-16 flex items-center justify-center ${service.color} rounded-full mb-6 group-hover:scale-110 transition-transform`}>
                <i className={`${service.icon} text-3xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                {service.description}
              </p>
              <a
                href="#contact"
                className="inline-flex items-center text-teal-600 font-semibold hover:text-teal-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                Learn More
                <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
